import React from 'react';
import { DeliveryTimelineItemStyled } from './DeliveryTimelineItemStyled';
import Icon from '../icons/ReturnIcons';
import { formatDateAndTime } from '../../../helpers/Helpers';
const DeliveryTimelineItem = ({ status, date, location, isCurrentStatus, isLastItem }) => {


    return (
        <DeliveryTimelineItemStyled currentStatus={isCurrentStatus} isLastItem={isLastItem}>
            <div className='timeline'>
                <span className='circle'></span>
                <span className='dash'></span>
            </div>
            <div className='timelineInfoWrapper'>
                <div>
                    <p className='title'>{status}</p>
                </div>
                <div className='dateLocationWrapper'>
                    {date && <span className='statusDate'>{formatDateAndTime(new Date(date))}</span>}
                    {location && <span className='statusLocation'><Icon src='pinIcon' /> <p>{location}</p></span>}
                </div>
            </div>
        </DeliveryTimelineItemStyled>
    );
};

export default DeliveryTimelineItem;